// Copyright (c) 2025 Audere, All Rights Reserved

import { createBrowserRouter, generatePath, Navigate, useParams } from "react-router";

import ErrorPage from "../screens/ErrorPage";
import Login from "../screens/Login";
import PrimaryAppBar from "../components/PrimaryAppBar";
import RequireAuth from "../components/RequireAuth";
import Projects from "../screens/Projects";
import CreatePage from "../screens/CreatePage";
import Dashboard from "../screens/Dashboard";
import NotFound from "../screens/NotFound";
import { CREATE_PROJECT_WITHOUT_TEST_PATH } from "../utils/constants";
import ManageSdk from "../screens/ManageSdk";

export const router = createBrowserRouter([
  {
    Component: PrimaryAppBar,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        Component: Login,
      },
      {
        Component: RequireAuth,
        children: [
          {
            path: "organization/:orgUid",
            Component: Projects,
            children: [
              {
                index: true,
                Component: () => {
                  const { orgUid } = useParams();
                  return (
                    <Navigate
                      to={generatePath(CREATE_PROJECT_WITHOUT_TEST_PATH, { orgUid: orgUid ?? "" })}
                      replace
                    />
                  );
                },
              },
              {
                path: "projects/create",
                Component: CreatePage,
              },
              {
                path: "projects/create/test/:testUid",
                Component: CreatePage,
              },
              {
                path: "projects/:projectUid",
                Component: CreatePage,
              },
              {
                path: "projects/:projectUid/test/:testUid",
                Component: CreatePage,
              },
              {
                path: "dashboard/projects/:projectUid/test/:testUid",
                Component: Dashboard,
              },
              {
                path: "projects/:projectUid/manage-sdk",
                Component: ManageSdk,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    Component: NotFound,
  },
]);
